import useUserProfileQuery from 'hooks/queries/useUserProfileQuery';
import useAffordaPortalDetailsQuery from 'hooks/queries/useAffordaPortalDetailsQuery';

const useShouldRedirectToWelcomeFlow = () => {
  const { isLoading: isUserProfileLoading, data: userProfile } =
    useUserProfileQuery();
  const {
    isLoading: isAffordaPortalDetailsLoading,
    data: affordaPortalDetails,
  } = useAffordaPortalDetailsQuery();

  const isLoading = isUserProfileLoading || isAffordaPortalDetailsLoading;
  const hasData =
    !isLoading &&
    Object.keys(userProfile ?? {}).length > 0 &&
    Object.keys(affordaPortalDetails ?? {}).length > 0;

  return {
    isLoading,
    shouldRedirectToWelcomeFlow: hasData
      ? userProfile?.isPrimaryProspect &&
        !affordaPortalDetails?.welcomeCompletedAt
      : null,
  };
};

export default useShouldRedirectToWelcomeFlow;
